import { Component, Prop } from 'vue-property-decorator';
import { BaseComponent } from '../base-component';
import { ApartmentPriceTableHeaderCell } from '../apartment-price-table-header-cell/apartment-price-table-header-cell';
import { ApartmentPriceTableRow } from '../apartment-price-table-row/apartment-price-table-row';
import { CGReservationStatus } from '../../enums/CGReservationStatus';
import { ApartmentFeature } from '../../enums/ApartmentFeature';
import { ApartmentPriceTableColumn } from '../../enums/ApartmentPriceTableColumn';
import { ApartmentSearchDTO } from '../../model/ApartmentSearchDTO';
import { ApartmentSearchSortType } from '../../enums/ApartmentSearchSortType';

@Component({
	components: {
		ApartmentPriceTableHeaderCell,
		ApartmentPriceTableRow
	}
})
export class ApartmentPriceTable extends BaseComponent {
	@Prop() items: ApartmentSearchDTO[];
	@Prop() hideColumns: ApartmentPriceTableColumn[];

	get allHideColumns() {
		return [...(this.hideColumns || []),
			...(!this.showSpecialEquipment ? [ApartmentPriceTableColumn.SpecialEquipment] : []),
			...(this.isPreview ? [ApartmentPriceTableColumn.Favorite] : []),
			...(!this.showBonus ? [ApartmentPriceTableColumn.Bonus] : [])]
	}

	get showPackagePrice() {
		return this.items.some(i =>
			i.packagePriceWithVAT > 0
			&& i.cgReservationStatus !== CGReservationStatus.ShowApartment
			&& ! i.features.includes(ApartmentFeature.PremiumPriceOnRequest)
		);
	}

	get showPackageInfo() {
		return this.items.some(i =>
			i.packageInfo !== null && i.packageInfo.length > 0
			&& i.cgReservationStatus !== CGReservationStatus.ShowApartment
			&& !i.features.includes(ApartmentFeature.PremiumPriceOnRequest)
		);
	}

	get showFinalDiscount() {
		return this.items.some(i =>
			i.finalDiscount > 0
			&& i.cgReservationStatus !== CGReservationStatus.ShowApartment
			&& !i.features.includes(ApartmentFeature.PremiumPriceOnRequest)
		);
	}

	get showSpecialEquipment() {
		return this.items.some(i => i.hasAirCondition || i.hasBuiltinWardrobe || i.hasHeatRecovery || i.hasHeatRecoveryWithoutCooling || i.hasJacuzzi
			|| i.hasKitchenCabinet || i.hasRollerBlinds || i.hasRollerBlindsPreparation
			|| i.hasRollerBlindsInPart || i.hasRollerBlindsPreparationInPart || i.hasRollerShutter || i.hasRollerShutterPreparation || i.hasRollerShutterInPart || i.hasRollerShutterPreparationInPart
		);
	}

	get showBonus() {
		return this.items.some(i => !!i.tooltip);
	}

	get isPreview() {
		return this.$route.query.predbezne && this.$route.query.csh;
	}

	showColumn(column: ApartmentPriceTableColumn) {
		return !this.allHideColumns || !this.allHideColumns.includes(column);
	}
}

export default ApartmentPriceTable;
